var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeechLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.09683 14.0277C7.98064 14.0277 7.53791 13.4533 7.53791 12.4051V3.95464C7.53791 2.94079 7.97752 2.3331 8.75595 2.3331H9.22882C11.3261 2.3331 13.6593 5.00277 13.6593 9.43109C13.6593 11.865 12.5763 14.0277 10.345 14.0277H9.09683ZM0.811679 24H8.25086C8.72477 24 9.06253 23.7632 9.06253 23.358V23.223C9.06253 22.2767 7.54103 21.8726 7.54103 20.3144V16.394H10.3471C16.1972 16.394 20.0186 13.0814 20.0186 8.01108C20.0186 2.29778 15.3523 0 9.2309 0H0.812718C0.30451 0 0 0.239958 0 0.643006V0.778047C0 1.72438 1.35107 2.16378 1.35107 3.68663V20.3144C1.35107 21.8726 0 22.2756 0 23.223V23.358C0 23.7632 0.304509 24 0.811679 24Z",
    fill: "#EA429D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeechLogoShort);
export default __webpack_public_path__ + "static/media/peechLogoShort.17311f26d61ceab613b8fd7b3be51ca4.svg";
export { ForwardRef as ReactComponent };